import maplibregl from "maplibre-gl";
import { createClusterGroupPopup } from "./mapMarkerPopupCluster";

/**
 * Create a single cluster marker (one per clusterGroup)
 *
 * @param {object} options
 * @param {maplibregl.Map} options.map
 * @param {object} options.cluster - clusterGroup
 * @param {function} options.onSelectMarkerGroup - (markerGroup) => void
 */
export function createClusterMarker({ map, cluster, onSelectMarkerGroup }) {
  if (!map || !cluster) return null;

  const el = document.createElement("div");
  el.className = "map-marker map-marker--cluster";

  // e.g. show the count
  const countEl = document.createElement("span");
  countEl.className = "map-marker--cluster__count";
  countEl.textContent = String(cluster.members.length);
  el.appendChild(countEl);

  const marker = new maplibregl.Marker({ element: el })
    .setLngLat([cluster.lng, cluster.lat])
    .addTo(map);

  const popup = createClusterGroupPopup({
    cluster,
    onSelectMarkerGroup,
  });

  marker.setPopup(popup);

  const destroy = () => {
    try {
      popup.remove();
    } catch {}
    try {
      marker.remove();
    } catch {}
  };

  return {
    marker,
    popup,
    destroy,
    clusterId: cluster.id,
  };
}
